import { combineReducers } from '@reduxjs/toolkit';
import { createTransform, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import notifications from '../../components/Notifications/reducer';
import scheduleEvents from '../../components/ScheduleEvents/reducer';
import habitat from '../../routes/habitat/reducer';
import magicLink from '../../routes/login/MagicLinkModal/reducer';
import passwordReset from '../../routes/login/ResetModal/reducer';
import map from '../../routes/map/reducer';
import schedule from '../../routes/schedule/reducer';
import deviceSettingsSlice from '../slices/deviceSettings';
import guidedTourSlice from '../slices/guidedTour';
import myAlbumSlice from '../slices/myAlbum';
import remoteConfigSlice from '../slices/remoteConfig';
import settingsSlice from '../slices/settings';
import userSlice from '../slices/user';
import allHabitats from './allHabitats';
import chat from './chat';
import config from './config';
import geoInfo from './geoInfo';
import mainStream from './mainStream';
import modals from './modals';

const settingsPersistConfig = {
  version: 2,
  key: 'settings',
  storage,
  blacklist: ['videoPlayerConfig'],
};

const remoteConfigPersistConfig = {
  version: 1,
  key: remoteConfigSlice.name,
  storage,
};

const deviceSettingsPersistConfig = {
  version: 1,
  key: deviceSettingsSlice.name,
  storage,
};

// On rehydrate, move feedback modal end-steps to End2 so users do not return to a stuck modal.
const guidedTourRehydrateTransform = createTransform(null, (subState, key) => {
  if (key !== 'stepHistory') return subState;
  const currentStepId = subState[subState.length - 1];
  if (currentStepId === 'modal-end' || currentStepId === 'modal-end-submitted') {
    return [...subState, 'End2'];
  }
  return subState;
});

const guidedTourPersistConfig = {
  version: 1,
  key: guidedTourSlice.name,
  storage,
  transforms: [guidedTourRehydrateTransform],
};

export default combineReducers({
  allHabitats,
  mainStream,
  [userSlice.name]: userSlice.reducer,
  chat,
  habitat,
  map,
  schedule,
  [myAlbumSlice.name]: myAlbumSlice.reducer,
  passwordReset,
  magicLink,
  modals,
  notifications,
  scheduleEvents,
  config,
  geoInfo,
  settings: persistReducer(settingsPersistConfig, settingsSlice),
  [remoteConfigSlice.name]: persistReducer(remoteConfigPersistConfig, remoteConfigSlice.reducer),
  [deviceSettingsSlice.name]: persistReducer(deviceSettingsPersistConfig, deviceSettingsSlice.reducer),
  [guidedTourSlice.name]: persistReducer(guidedTourPersistConfig, guidedTourSlice.reducer),
});
